import React from 'react';
import { WarningTriangleFilled } from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';
import { Alert } from 'AppSrc/core/components/utility/alert';

const CrqListErrorAlert = ({ clearError }) => {
  const alertData = {
    className: 'alert-error',
    showFalse: false,
    alertTitle: 'Unable to retrieve CRQs from the server. Please try again later',
    Icon: WarningTriangleFilled,
  };
  return (
    <Alert
      alertData={alertData}
      resolveAlert={(boolean) => clearError()}
    />
  );
};

CrqListErrorAlert.propTypes = {
  clearError: PropTypes.func,
};

export { CrqListErrorAlert };
